import { useMutation } from '@tanstack/react-query';

import { endpoints } from 'global/endpoints';
import http from 'utils/http';

export interface IBulkClockin {
  user_ids: Array<number>;
  job_id?: number;
  task_id?: number;
  latitude?: number;
  longitude?: number;
  speed?: number;
  clock_in_time?: string;
  offset?: any;
  timezone?: string;
  source?: 'quick-time-clock';
}

const bulkClockIn = (postData: IBulkClockin) => {
  return http().post(endpoints.timeClock.bulkClockIn, postData);
};

export function useBulkClockIn() {
  return useMutation({ mutationFn: bulkClockIn });
}
